<template>
  <div id="bsczhu1">
    <div class="box">
      <div id="bsczhu1div" style="height:99%"></div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from "echarts";

export default {
  name: "bsczhu1",
  data() {
    return {
      // 需要合并对象，样式
      legendColor: false,
      mm: 5,
      dataset: [[-10, 5, -3]],
      NowYearTargetValue: ["内饰", "外饰", "AYM"],
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
  },
  methods: {
    refreshChart(chartData) {
      // 生成数据
      const data1 = [];
      const titleData = [];
      if (chartData !== undefined) {
        for (let i = 0; i < chartData.length; i++) {
          titleData.push(chartData[i].DisplayName);
          const item = {
            name: chartData[i].DisplayName,
            value: chartData[i].PracticalValue,
          };
          data1.push(item);
        }
      }
      this.dataset = data1;
      this.NowYearTargetValue = titleData;

      var myChart = echarts.init(document.getElementById("bsczhu1div"));

      var option = {
        title: {
          text: this.locale('Energy Consumption(tce)','综合能耗(吨标煤)'),
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          left: "left",
          y: 5
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        color: [
          "#87CDEB",
          "#5FBCE4",
          "#40AFDF",
          "#239DD1",
          "#1E86B3",
          "#186B8F",
        ],
        /*
        legend: {
          orient: 'vertical',
          x: '30',
          top: '15',
          textStyle: {
            color: '#fff'
          },
          data: this.NowYearTargetValue
        },
        */
        series: [
          {
            name: this.locale('Energy Consumption(tce)','综合能耗(吨标煤)'),
            type: "pie",
            radius: "65%",
            center: ["50%", "50%"],
            selectedMode: "single",
            data: this.dataset,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
                normal: {
                    textStyle : {
                        fontSize: 16
                    }
                }
            },
            itemStyle: {
              normal: {
                label: {
                  formatter: function (p) {
                    return (
                      p.data.name +":" +p.data.value
                    );
                  },
                },
              }
            },
          },
        ],
      };
      // 5：展示数据
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" >
#bsczhu1 {
  position: relative;
  width: 99%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  // margin-left: 10px;
  margin-right: 10px;
  .box {
    height: 100%;
    width: 100%;
  }
}
</style>
